<template>
  <v-dialog v-model="openFilter" persistent max-width="450">
    <v-card>
      <v-card-title>Filters</v-card-title>
      <v-card-text>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.kind__in" label="Ticket type" :items="ticketFilters.kind" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" outlined dense class="mb-n6" multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.status__in" label="Status" :items="ticketFilters.status" :disabled="ticketFiltersLoading || escalation" :loading="ticketFiltersLoading" outlined dense class="mb-n6" multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.agent__in" label="Agent" :items="ticketFilters.agents" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" outlined dense class="mb-n6" multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.escalation_agent__in" label="Escalation agent" :items="ticketFilters.agents" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" outlined dense class="mb-n6" multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.team__in" label="Department" :items="getTicketTeams" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" outlined dense class="mb-n6" multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select v-model="filters.cause__in" label="Cause" :items="getTicketCauses" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" multiple hide-details outlined dense ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>

              <v-menu ref="menu1" v-model="createdMenu" :close-on-content-click="false" :return-value.sync="created" transition="scale-transition" offset-y>
                
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="created" label="Created" readonly dense outlined :hide-details="!dateRangeCreatedError.length > 0" v-bind="attrs" v-on="on" :error-messages="dateRangeCreatedError" @input="$v.created.$touch()"
                  @blur="$v.created.$touch()">

                    <template v-if="created.length!==0" #append>
                      <v-icon color="error" @click="clearCreatedDate">close</v-icon>                 
                    </template>

                  </v-text-field>
                </template>

                <v-date-picker v-model="created" range no-title width="400px">
                  <v-btn color="warning" small outlined @click="clearCreatedCalendar">CLEAR</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" small @click="saveCreatedCalendar">Ok</v-btn>
                  <v-btn color="primary" small class="ml-3" outlined @click="createdMenu = false;">Cancel</v-btn>
                </v-date-picker>
              </v-menu>

          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="filters.supplier_ticket_id" label="Supplier ticket ID" :disabled="ticketFiltersLoading" :loading="ticketFiltersLoading" hide-details outlined dense></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-switch v-model="escalation" label="Escalated"></v-switch>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearForm()">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submitForm()" :loading="ticketFiltersLoading">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState,mapActions,mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { minLength } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  mixins: [validationMixin],

  validations: {
    created: { minLength: minLength(2) },
  },

  data () {
    return {
      createdMenu: false,
      created: [],
      escalation: false,
      filters: {
        kind__in: [],
        status__in: [],
        agent__in: [],
        escalation_agent__in: [],
        team__in: [],
        cause__in: [],
        supplier_ticket_id: null,
      },
    }
  },

  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },

  watch: {
    async openFilter(val) {
      if(val){
        this.filters.kind__in = this.getTicketsConfigs.queryParams.kind__in;
        this.filters.status__in = this.getTicketsConfigs.queryParams.status__in;
        this.filters.agent__in = this.getTicketsConfigs.queryParams.agent__in;
        this.filters.escalation_agent__in = this.getTicketsConfigs.queryParams.escalation_agent__in;
        this.filters.team__in = this.getTicketsConfigs.queryParams.team__in;
        this.filters.cause__in = this.getTicketsConfigs.queryParams.cause__in;
        this.filters.supplier_ticket_id = this.getTicketsConfigs.queryParams.supplier_ticket_id;
        this.escalation = this.getTicketsConfigs.queryParams.status__in && this.getTicketsConfigs.queryParams.status__in.length === 1 && this.getTicketsConfigs.queryParams.status__in[0] === 'escalation';
        if(this.getTicketsConfigs.queryParams.creation_timestamp__gte && this.getTicketsConfigs.queryParams.creation_timestamp__lte) {
          this.created = [moment(this.getTicketsConfigs.queryParams.creation_timestamp__gte).format("YYYY-MM-DD"), moment(this.getTicketsConfigs.queryParams.creation_timestamp__lte).format("YYYY-MM-DD")];
        } else {
          this.created = [];
        }
        
        if(this.ticketFilters.agents===undefined){
          await this.fetchTicketFilters();
        }
      }
    },
  },

  computed: {
    ...mapState('tickets',['ticketFilters','ticketFiltersLoading']),
    ...mapGetters('tickets',['getTicketsConfigs','getTicketTeams', 'getTicketCauses']),

    dateRangeCreatedError() {
      const errors = [];
      !this.$v.created.minLength && errors.push("Created: requires a date range to be selected.");
      return errors;
    },

    getStatusIn() {
      if(this.escalation) {
        return { status__in: ["escalation"] };
      }
      return { status__in: this.filters.status__in };
    }
  },

  methods: {
    ...mapActions('tickets', ['updateTicketsPagination','fetchTicketFilters']),

    closeDialog(){this.$emit('closeDialog');},

    clearCreatedDate() {
      this.created = [];
    },

    saveCreatedCalendar() {
      if (this.created.length !== 0 ) {
        this.created = this.created.sort();
      }
      this.$refs.menu1.save(this.created);
    },

    clearCreatedCalendar() {
      this.clearCreatedDate();
      this.saveCreatedCalendar();
    },

    clearForm() {
      this.filters.kind__in = [];
      this.filters.status__in = [];
      this.filters.agent__in = [];
      this.filters.escalation_agent__in = [];
      this.filters.team__in = [];
      this.filters.cause__in = [];
      this.filters.supplier_ticket_id = null;
      this.created = [];
      this.escalation = false;
    },

    submitForm() {
      this.$v.$touch();
      if(!this.$v.$invalid) {
        this.filters.page = 1;
        this.filters.paginationCount = 0;
        this.updateTicketsPagination({ 
          queryParams: {
            ...this.filters,
            ...this.getStatusIn,
            creation_timestamp__gte: this.created[0] ? `${this.created[0]}T00:00:00` : null,
            creation_timestamp__lte: this.created[1] ? `${this.created[1]}T23:59:59` : null,
          }
        });
        this.$emit('closeDialog', false);
      }
    }
  },
}
</script>

<style></style>
